import { CAL_SOFTWARE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: CAL_SOFTWARE_MNG,
  params: null,
  view: {
    title: '创建软件',
    labelPosition: 'right',
    content: [
      {
        $id: 'softwareName',
        $type: 'input',
        label: '软件名称',
        $el: {
          placeholder: '请输入软件名称',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '软件名称不能为空'
          }
        ]
      },
      {
        $id: 'softwareType',
        $type: 'select',
        label: '软件类型',
        $el: {
          placeholder: '请选择软件类型',
          suffixIcon: 'el-icon-edit',
          filterable: true
        },
        $options: [
          {
            label: '杀毒软件',
            value: 'ANTIVIRUS'
          },
          {
            label: '加密软件',
            value: 'ENCRPYTION'
          }
        ],
        rules: [
          {
            notEmpty: 'softwareType'
          }
        ]
      },
      {
        $id: 'reduceConcurrency',
        $type: 'input-number',
        label: '减少并发率',
        $el: {
          placeholder: '请输入减少并发率',
          suffixIcon: 'el-icon-edit',
          min: 0
        },
        rules: [
          {
            notEmpty: '减少并发率不能为空'
          }
        ]
      }
    ]
  }
}
